import React, { useEffect, useState } from "react";
import { RootState } from "packages/web/src/reducers";
import { fetchNotificationGroups } from "@rpforms/shared/build/actions/notification_groups";
import { useSelector, useDispatch } from "react-redux";
import { ObviousNotification } from "../ObviousNotification";

export const BatteryMaintenanceNotifications = () => {
    const [expanded, setExpanded] = useState(true);
    const dispatch = useDispatch();
    const notificationGroups = useSelector<RootState, any>(
        (store) => store.notificationGroups.notification_groups
    );

    useEffect(() => {
        dispatch(fetchNotificationGroups(1, () => {}));
    }, []);

    const batteryGroup = notificationGroups.find((group) => group.slug === "akku-wartung");

    const batteryNotifications = batteryGroup?.notifications || [];

    if (batteryNotifications.length === 0) {
        return null;
    }

    return (
        <ObviousNotification
            expanded={expanded}
            setExpanded={setExpanded}
            title="Akku Wartung erforderlich"
            message={`Es gibt ${batteryNotifications.length} ungelesene ${
                batteryNotifications.length === 1
                    ? "Akku-Wartungsbenachrichtigung"
                    : "Akku-Wartungsbenachrichtigungen"
            }.`}
            faIcon="fa-battery-quarter"
            link="/notifications/group/akku-wartung"
            alertVariant="warning"
        />
    );
};
